<template>
    <div
        class="plugins-container"
    >
        <p
            v-if="integrationPlugins"
            class="tools-title"
        >
            Tools:
        </p>
        <template
            v-for="plugin in integrationPlugins"
>
            <div
                :key="plugin.name"
                class="plugin"
            >
                <integration-plugin
                    :plugin="plugin"
                />
            </div>
        </template>
    </div>
</template>

<script>
import IntegrationPlugin from './IntegrationPlugin.vue';

export default {
    components: { IntegrationPlugin },

    props: {
        integrationPlugins: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
